import { buildModelManager } from "../builder.js";
const DefaultClinicalDocumentProcessorSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  customSettings: true,
  defaultForPlatform: true,
  description: { markdown: true, truncatedHTML: true },
  documentPlatform: true,
  evaluationCriteria: true,
  evaluationFields: true,
  fieldMappings: true,
  isActive: true,
  isSharedResource: true,
  lastModifiedById: true,
  lastUsedAt: true,
  modelSettings: true,
  name: true,
  outputFormat: true,
  ownerInstitution: true,
  parentProcessorId: true,
  passingThresholds: true,
  processingSettings: true,
  processorVersion: true,
  requiresApproval: true,
  sharePermissions: true,
  sharedWithInstitutions: true,
  successRate: true,
  systemInstructions: { markdown: true, truncatedHTML: true },
  templateData: true,
  updatedAt: true,
  usageCount: true,
  validationRules: true
};
const modelApiIdentifier = "clinicalDocumentProcessor";
const pluralModelApiIdentifier = "clinicalDocumentProcessors";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalDocumentProcessorSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createClinicalDocumentProcessor",
    operationReturnType: "CreateClinicalDocumentProcessor",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      clinicalDocumentProcessor: { required: false, type: "CreateClinicalDocumentProcessorInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "action",
    operationName: "bulkCreateClinicalDocumentProcessors",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateClinicalDocumentProcessorsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "action",
    operationName: "updateClinicalDocumentProcessor",
    operationReturnType: "UpdateClinicalDocumentProcessor",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clinicalDocumentProcessor: { required: false, type: "UpdateClinicalDocumentProcessorInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateClinicalDocumentProcessors",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateClinicalDocumentProcessorsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "action",
    operationName: "deleteClinicalDocumentProcessor",
    operationReturnType: "DeleteClinicalDocumentProcessor",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteClinicalDocumentProcessors",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertClinicalDocumentProcessor",
    operationReturnType: "UpsertClinicalDocumentProcessor",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      clinicalDocumentProcessor: { required: false, type: "UpsertClinicalDocumentProcessorInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateClinicalDocumentProcessorResult": { hasReturnType: false },
      "... on UpdateClinicalDocumentProcessorResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertClinicalDocumentProcessors",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertClinicalDocumentProcessorsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultClinicalDocumentProcessorSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clinicalDocumentProcessorGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClinicalDocumentProcessorManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClinicalDocumentProcessorSelection,
  operations
);
export {
  ClinicalDocumentProcessorManager,
  DefaultClinicalDocumentProcessorSelection
};
//# sourceMappingURL=ClinicalDocumentProcessor.js.map
